export default "__VITE_ASSET__CemsdH7v__"